import { render, staticRenderFns } from "./OrganizationResidents.vue?vue&type=template&id=2ee832bc&"
import script from "./OrganizationResidents.vue?vue&type=script&lang=js&"
export * from "./OrganizationResidents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports